import { MessageDto } from "@reactive-resume/dto";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";

export const confirmEmailChange = async (data: { token: string }) => {
  const response = await axios.post<MessageDto, AxiosResponse<MessageDto>>(
    "/auth/confirm-email-change",
    data,
  );

  return response.data;
};

export const useConfirmEmailChange = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: confirmEmailChangeFn,
  } = useMutation({
    mutationFn: confirmEmailChange,
  });

  return { confirmEmailChange: confirmEmailChangeFn, loading, error };
};
